import * as React from 'react';
var TableContext = /*#__PURE__*/React.createContext(null);
export default TableContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-table/es/context/TableContext.js
// module id = 39
// module chunks = 0